import { motion } from "motion/react";
import { partners } from "../lib/landingData";
import { BrandLogo } from "../components/BrandLogo";
import { Zap } from "lucide-react";

const iconMap = {
  Zap: Zap,
} as const;

export function PartnersSection() {
  return (
    <section className="relative py-24 px-4 sm:px-6 lg:px-8 border-y border-white/5 bg-white/[0.02]">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter text-foreground mb-4">
            Powered by best-in-class partners
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            We integrate with the infrastructure and platforms you already trust.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="flex flex-wrap items-center justify-center gap-4"
        >
          {partners.map((brand) => {
            const CustomIcon = brand.icon ? iconMap[brand.icon as keyof typeof iconMap] : undefined;
            return (
              <BrandLogo
                key={brand.name}
                name={brand.name}
                slug={brand.slug}
                icon={CustomIcon}
                iconColor={brand.iconColor}
              />
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
